<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" style="margin-top:1vh;" width="1200px"
      :close-on-click-modal="false">
      <div slot="title" class="title">客户联系统计</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="商品统计" name="goods">
          <div class="table-container">
            <div class="btn-wrap">
              <el-input style="width: 200px;margin-right: 10px;" v-model="table1Params.chatName" size="mini"
                placeholder="商品名称" clearable @clear="getTableData1" @blur="getTableData1" />
              <el-date-picker v-model="searchSelectTime1" size="mini" :editable="false" type="daterange"
                value-format="yyyy-MM-dd" range-separator="-" start-placeholder="发送开始时间" end-placeholder="发送结束时间"
                :picker-options="pickerOptions" @change="selectTime1" clearable style="width: 240px;">
              </el-date-picker>
            </div>
            <div class="table-data">
              <el-table size="medium" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" ref="singleTable"
                v-loading="loading1" :highlight-current-row="true" :data="tableData1" @sort-change="customerSortChange1"
                :default-sort="{ prop: 'shareNumber', order: 'descending' }" height="308px"
                style="width: 100%;height:100%;font-size: 13px">
                <el-table-column show-overflow-tooltip prop="name" label="商品名称" width="118"
                  align="left"></el-table-column>
                <el-table-column prop="shareNumber" label="发送次数" sortable="custom" min-width="102"
                  align="center"></el-table-column>
                <el-table-column prop="shareOpenNumber" label="点击次数" sortable="custom" min-width="102"
                  align="center"></el-table-column>
                <el-table-column prop="openRate" label="打开率" sortable="custom" min-width="144"
                  align="center"></el-table-column>
                <el-table-column prop="shelvesOrderNumber" label="商品成交量" sortable="custom" min-width="102"
                  align="center"></el-table-column>
                <el-table-column prop="orderRate" label="商品成交率" sortable="custom" min-width="102"
                  align="center"></el-table-column>
              </el-table>
            </div>
            <div class="staff-pagination">
              <el-pagination @current-change="getTableData1" @size-change="getTableData1"
                :current-page.sync="table1Params.page" :page-size.sync="table1Params.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total1" :page-sizes="[20, 50, 100, 200, 500]">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="活动统计" name="act">
          <div class="table-container">
            <div class="btn-wrap">
              <el-input style="width: 200px;margin-right: 10px;" v-model="table2Params.chatName" size="mini"
                placeholder="活动名称" clearable @clear="getTableData2" @blur="getTableData2" />
              <el-date-picker v-model="searchSelectTime2" size="mini" :editable="false" type="daterange"
                value-format="yyyy-MM-dd" range-separator="-" start-placeholder="发送开始时间" end-placeholder="发送结束时间"
                :picker-options="pickerOptions" @change="selectTime2" clearable style="width: 240px;">
              </el-date-picker>
            </div>
            <div class="table-data">
              <el-table size="medium" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" ref="singleTable"
                v-loading="loading2" :highlight-current-row="true" :data="tableData2" @sort-change="customerSortChange2"
                :default-sort="{ prop: 'shareNumber', order: 'descending' }" height="308px"
                style="width: 100%;height:100%;font-size: 13px">
                <el-table-column show-overflow-tooltip prop="name" label="商品名称" width="118"
                  align="left"></el-table-column>
                <el-table-column prop="shareNumber" label="发送次数" sortable="custom" min-width="102"
                  align="center"></el-table-column>
                <el-table-column prop="shareOpenNumber" label="点击次数" sortable="custom" min-width="102"
                  align="center"></el-table-column>
                <el-table-column prop="openRate" label="打开率" sortable="custom" min-width="144"
                  align="center"></el-table-column>
                <el-table-column prop="shelvesOrderNumber" label="商品成交量" sortable="custom" min-width="102"
                  align="center"></el-table-column>
                <el-table-column prop="orderRate" label="商品成交率" sortable="custom" min-width="102"
                  align="center"></el-table-column>
              </el-table>
            </div>
            <div class="staff-pagination">
              <el-pagination @current-change="getTableData2" @size-change="getTableData2"
                :current-page.sync="table2Params.page" :page-size.sync="table2Params.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total2" :page-sizes="[20, 50, 100, 200, 500]">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { shopDetailApi, activityDetailApi } from "@/api/commodityBoard.js";
export default {
  name: 'customerContact',
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'goods',
      searchSelectTime1: '',
      table1Params: {
        userIdList: [],    //员工userId数组【非必传】
        sendStartTime: "",    //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        sendEndTime: "",    //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        sort: "",
        asc: null,
        page: 1,    //页码
        pageSize: 10    //页数
      },
      total1: 0,
      tableData1: [],
      loading1: false,
      // 禁选时间
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          const day = 180 * 24 * 3600 * 1000;
          return time.getTime() > new Date(new Date().setHours(23, 59, 59, 999)).getTime() - 8.64e7 || time.getTime() < (curDate - day);
        },
      },

      searchSelectTime2: '',
      table2Params: {
        userIdList: [],    //员工userId数组【非必传】
        sendStartTime: "",    //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        sendEndTime: "",    //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        sort: "",
        asc: null,
        page: 1,    //页码
        pageSize: 10    //页数
      },
      total2: 0,
      tableData2: [],
      loading2: false,
    }
  },
  methods: {
    show(tab) {
      this.activeName = tab
      this.dialogVisible = true;
      if (this.activeName == 'act') {
        this.getTableData2()
      } else {
        this.getTableData1()
      }
    },
    handleClick(val) {
      if (val == 'act') {
        this.getTableData2()
      } else {
        this.getTableData1()
      }
    },
    dateChange1(val) {
      this.searchSelectTime1 = ''
      this.table1Params.sendStartTime = ''
      this.table1Params.sendEndTime = ''
      this.table1Params.page = 1
      this.getTableData1()
    },
    customerSortChange1(val) {
      console.log('排序-----', val);
      this.table1Params.sort = val.prop
      if (val.column.order === "descending") {
        this.table1Params.asc = false
      } else if (val.column.order === "ascending") {
        this.table1Params.asc = true
      }
      this.table1Params.page = 1
      this.getTableData1()
    },
    selectTime1(dataTime) {
      if (dataTime != null) {
        this.table1Params.sendStartTime = (new Date(dataTime[0])).getTime()
        this.table1Params.sendEndTime = (new Date(dataTime[1])).getTime()
      } else {
        this.table1Params.sendStartTime = ''
        this.table1Params.sendEndTime = ''
      }
      this.table1Params.page = 1
      this.getTableData1()
    },
    // 获取表格数据
    getTableData1() {
      this.loading1 = true
      shopDetailApi(this.table1Params, localStorage.getItem("Authorization"), true).then(res => {
        this.loading1 = false
        if (res.error.code == 200 && res.data.records) {
          this.tableData1 = res.data.records
          this.total1 = Number(res.data.total || 0)
        } else {
          this.total1 = 0
        }
      }).catch((err) => {
        this.total1 = 0
        this.$message.error('获取表格数据失败，请重试！')
        this.loading1 = false
      })
    },



    dateChange2(val) {
      this.searchSelectTime2 = ''
      this.table2Params.sendStartTime = ''
      this.table2Params.sendEndTime = ''
      this.table2Params.page = 1
      this.getTableData2()
    },
    customerSortChange2(val) {
      console.log('排序-----', val);
      this.table2Params.sort = val.prop
      if (val.column.order === "descending") {
        this.table2Params.asc = false
      } else if (val.column.order === "ascending") {
        this.table2Params.asc = true
      }
      this.table2Params.page = 2
      this.getTableData2()
    },
    selectTime2(dataTime) {
      if (dataTime != null) {
        this.table2Params.sendStartTime = (new Date(dataTime[0])).getTime()
        this.table2Params.sendEndTime = (new Date(dataTime[2])).getTime()
      } else {
        this.table2Params.sendStartTime = ''
        this.table2Params.sendEndTime = ''
      }
      this.table2Params.page = 1
      this.getTableData2()
    },
    // 获取表格数据
    getTableData2() {
      this.loading2 = true
      activityDetailApi(this.table2Params, localStorage.getItem("Authorization"), true).then(res => {
        this.loading2 = false
        if (res.error.code == 200 && res.data.records) {
          this.tableData2 = res.data.records
          this.total2 = Number(res.data.total || 0)
        } else {
          this.total2 = 0
        }
      }).catch((err) => {
        this.total2 = 0
        this.$message.error('获取表格数据失败，请重试！')
        this.loading2 = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  /deep/.select-stafft-wrap {
    margin-right: 10px;
    width: 180px;
    position: relative;
    cursor: pointer;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;

    .el-icon-close {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
    }

    .staff-names {
      color: #606266;
    }
  }

  /deep/ .el-tag--plain {
    border-color: #DCDFE6;
    color: #C0C4CF;
  }
}

.table-data {
  margin-bottom: 16px;
}

.btn-group {
  margin-right: 12px;
  display: flex;
  align-items: center;
  background-color: white;
  cursor: pointer;
  font-size: 13px;

  .btn {
    padding: 5px 16px;
    border: 1px solid #E6E9EB;

    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-right: none;
    }

    &:not(:first-child):not(:last-child) {
      border-radius: 0;
      border-right: none;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &:hover {
      color: #409EFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }

  .btn-active {
    color: white;
    border-color: #4080F9;
    background-color: #4080F9;

    &:hover {
      color: white;
      border-color: #4080F9;
      background-color: #4080F9;
    }
  }
}

// /deep/.el-pagination {
//   .btn-prev,.btn-next {
//     background-color: white;
//     border: 1px solid #E6E9EB;
//   }
//   .el-pager  {
//     li {
//       background-color: white;
//       // border: 1px solid #2684FF;
//       color: rgba(0, 0, 0, 0.6);
//       border: 1px solid #E6E9EB;
//       border-radius: 2px;
//     }
//     li:not(.disabled).active {
//       border: 1px solid #2684FF;
//       color: #2684FF;
//       background-color: white;
//     }
//   }
// }
/deep/ .el-dialog__header {
  padding: 28px 28px 10px 32px;
}

/deep/ .el-dialog__body {
  padding: 14px 32px 6px;
}

/deep/ .el-dialog__footer {
  padding: 4px 32px 32px;

  .el-button {
    width: 88px;
    height: 32px;
    padding: 0;
  }
}


.staff-pagination {
  display: flex;
  justify-content: flex-end;
}
</style>